/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type InvoiceStatus = "DRAFT" | "OVERDUE" | "PAID" | "PARTIALLY_PAID" | "SENT" | "VOID";
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoicesTable_invoiceEdges$ref: FragmentReference;
declare export opaque type InvoicesTable_invoiceEdges$fragmentType: InvoicesTable_invoiceEdges$ref;
export type InvoicesTable_invoiceEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +invoiceNumber: string,
    +status: InvoiceStatus,
    +currency: string,
    +totalAmount: number,
    +amountDue: number,
    +issueDate: ?any,
    +dueDate: ?any,
    +notes: ?string,
    +order: ?{|
      +id: string,
      +orderNumber: string,
    |},
    +customer: {|
      +id: string,
      +name: string,
    |},
    +createdAt: any,
    +updatedAt: any,
  |},
  +$refType: InvoicesTable_invoiceEdges$ref,
|}>;
export type InvoicesTable_invoiceEdges$data = InvoicesTable_invoiceEdges;
export type InvoicesTable_invoiceEdges$key = {
  +$data?: InvoicesTable_invoiceEdges$data,
  +$fragmentRefs: InvoicesTable_invoiceEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "InvoicesTable_invoiceEdges",
  "type": "InvoiceEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Invoice",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "invoiceNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalAmount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "amountDue",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "issueDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "dueDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "order",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "orderNumber",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "customer",
          "storageKey": null,
          "args": null,
          "concreteType": "Customer",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "updatedAt",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f71fd13fbbfc2fcbc2f0bc006d8c225';
module.exports = node;
